(function () {
  function parseJSON(node, fallback) {
    if (!node) return fallback;

    try {
      return JSON.parse(node.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeActionStatus(value) {
    return String(value || '').trim().replace(/[^a-z0-9]+/gi, '').toLowerCase();
  }

  function normalizeReference(value) {
    return String(value || '').trim().replace(/^#/, '').replace(/\s+/g, '').toLowerCase();
  }

  function displayText(value, limit) {
    return typeof value === 'string' ? value.slice(0, limit || 500) : '';
  }

  function safeProductImage(value) {
    if (typeof value !== 'string') return null;
    try {
      var image = new URL(value, window.location.origin);
      var validPath = image.pathname.indexOf('/cdn/shop/') === 0;
      var validShopifyCdn = image.hostname === 'cdn.shopify.com';
      return image.protocol === 'https:' && (image.origin === window.location.origin && validPath || validShopifyCdn) &&
        !image.username && !image.password && !image.port && !image.hash ? image.href : null;
    } catch (error) {
      return null;
    }
  }

  function normalizePaidReturnRequests(requests) {
    if (!Array.isArray(requests) || requests.length > 250) throw new Error('Invalid paid return requests');
    return requests.map(function (request) {
      if (!request || typeof request.orderReference !== 'string' || typeof request.selectedProducts !== 'string' ||
        typeof request.paymentCompleted !== 'boolean' || (request.selectedLineItemIds !== undefined &&
        (!Array.isArray(request.selectedLineItemIds) || request.selectedLineItemIds.length > 250 ||
        request.selectedLineItemIds.some(function (id) { return (typeof id !== 'string' && typeof id !== 'number') || !String(id); }))))
        throw new Error('Invalid paid return request');
      request.selectedLineItemIds = (request.selectedLineItemIds || []).map(String);
      return request;
    }).filter(function (request) { return request.paymentCompleted; });
  }

  function normalizeAccountOrders(data) {
    if (!data || data.schemaVersion !== 3 || !data.customer || typeof data.customer.loggedIn !== 'boolean' ||
      !Array.isArray(data.orders) || data.orders.length > 250) throw new Error('Invalid account response');
    if (!data.customer.loggedIn) return [];
    var paid = normalizePaidReturnRequests(data.paidReturnRequests || []);
    var orderIds = new Set();
    var itemIds = new Set();
    return data.orders.map(function (order, orderIndex) {
      if (!order || typeof order.id !== 'string' || !order.id || orderIds.has(order.id) ||
        typeof order.name !== 'string' || !order.name || typeof order.withdrawalEligible !== 'boolean' ||
        (order.cancelled !== undefined && typeof order.cancelled !== 'boolean') ||
        !Array.isArray(order.items) || order.items.length > 250) throw new Error('Invalid account order');
      orderIds.add(order.id);
      var returnProducts = displayText(order.returnRequestProducts);
      var returnedLineItemIds = new Set();
      var returnStatus = displayText(order.returnRequestStatus, 100);
      paid.forEach(function (request) {
        if (normalizeReference(request.orderReference) === normalizeReference(order.id) ||
          normalizeReference(request.orderReference) === normalizeReference(order.name)) {
          returnProducts = [returnProducts, displayText(request.selectedProducts)].filter(Boolean).join(', ');
          (request.selectedLineItemIds || []).forEach(function (lineItemId) {
            returnedLineItemIds.add(String(lineItemId));
          });
          if (!returnStatus) returnStatus = displayText(request.status, 100) || 'Return requested';
        }
      });
      var items = order.items.map(function (item, itemIndex) {
        if (!item || (typeof item.lineItemId !== 'string' && typeof item.lineItemId !== 'number') ||
          !String(item.lineItemId) || itemIds.has(String(item.lineItemId)) ||
          typeof item.withdrawalInitiated !== 'boolean' || !Number.isSafeInteger(item.quantity) || item.quantity < 1 ||
          !Number.isSafeInteger(item.returnableQuantity) || item.returnableQuantity < 0 || item.returnableQuantity > item.quantity)
          throw new Error('Invalid account item');
        itemIds.add(String(item.lineItemId));
        var title = displayText(item.title) || 'Order item';
        var initiated = item.withdrawalInitiated || returnedLineItemIds.has(String(item.lineItemId));
        return { id: String(item.lineItemId), lineItemId: String(item.lineItemId), title: title,
          variantTitle: displayText(item.variantTitle), sku: displayText(item.sku, 100), quantity: item.quantity,
          returnableQuantity: item.returnableQuantity, unitPriceMinor: Number.isSafeInteger(item.unitPriceMinor) && item.unitPriceMinor >= 0 ? item.unitPriceMinor : 0,
          currency: typeof item.currency === 'string' && /^[A-Z]{3}$/.test(item.currency) ? item.currency : '', image: safeProductImage(item.image),
          withdrawalInitiated: !!initiated, selectable: !initiated && item.returnableQuantity > 0 };
      });
      return { id: order.id, name: displayText(order.name, 100), orderNumber: displayText(order.orderNumber, 100),
        processedAt: displayText(order.processedAt, 100), processedAtRaw: displayText(order.processedAtRaw, 30), total: displayText(order.total, 100),
        financialStatus: displayText(order.financialStatus, 100), fulfillmentStatus: displayText(order.fulfillmentStatus, 100), cancelled: order.cancelled === true,
        cancelledAt: displayText(order.cancelledAt, 30), returnRequestStatus: returnStatus, returnRequestProducts: returnProducts,
        withdrawalEligible: order.withdrawalEligible, withdrawalMessage: displayText(order.withdrawalMessage), items: items };
    });
  }

  function sameOriginViewUrl(value) {
    try {
      var endpoint = new URL(value, window.location.origin);
      return endpoint.origin === window.location.origin && endpoint.pathname.endsWith('/cart') &&
        endpoint.searchParams.get('view') === 'eu-withdrawal-orders' && Array.from(endpoint.searchParams.keys()).length === 1 && !endpoint.hash ? endpoint.href : '';
    } catch (error) { return ''; }
  }

  function findByDataItem(root, selector, itemId) {
    var nodes = root.querySelectorAll(selector);
    var id = String(itemId);

    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i].getAttribute('data-item-id') === id) return nodes[i];
    }

    return null;
  }

  function withTimeout(ms) {
    if (!window.AbortController) {
      return { signal: undefined, clear: function () {} };
    }

    var controller = new AbortController();
    var timer = window.setTimeout(function () {
      controller.abort();
    }, ms);

    return {
      signal: controller.signal,
      clear: function () {
        window.clearTimeout(timer);
      }
    };
  }

  function parseResponseJSON(response) {
    return response.text().then(function (text) {
      if (!text) return {};

      try {
        return JSON.parse(text);
      } catch (error) {
        return {};
      }
    });
  }

  function createRequestError(defaultMessage, response) {
    var error = new Error(defaultMessage || 'Request failed');
    if (response) error.status = response.status;
    return error;
  }

  function setHidden(node, shouldHide) {
    if (!node) return;
    node.hidden = shouldHide;
  }

  function initWithdrawalForm(root) {
    if (!root || root.dataset.cpWithdrawalBound === 'true') return;
    root.dataset.cpWithdrawalBound = 'true';

    var requestForm = root.querySelector('[data-cp-withdrawal-request-form]');
    var submitForm = root.querySelector('[data-cp-withdrawal-submit-form]');
    var messageNode = root.querySelector('[data-cp-withdrawal-message]');
    var asideNode = root.querySelector('.cp-withdrawal__aside');
    var surfaceNode = root.querySelector('.cp-withdrawal__surface');
    var selectPanel = root.querySelector('[data-cp-step-panel="2"]');
    var ordersNode = root.querySelector('[data-cp-withdrawal-orders]');
    var itemsNode = root.querySelector('[data-cp-withdrawal-items]');
    var cancelHelperNode = root.querySelector('[data-cp-cancel-helper]');
    var backToLookupButton = root.querySelector('[data-cp-back-to-lookup]');
    var backToRequestButton = root.querySelector('[data-cp-back-to-request]');
    var startAgainButton = root.querySelector('[data-cp-start-again]');
    var retryAccountOrdersButton = root.querySelector('[data-cp-retry-account-orders]');
    var nextStepButton = root.querySelector('[data-cp-next-step-button]');
    var nextStepButtonText = root.querySelector('[data-cp-next-step-button-text]');
    var submitButton = root.querySelector('[data-cp-submit-button]');
    var submitButtonText = root.querySelector('[data-cp-submit-button-text]');
    var reviewSummary = root.querySelector('[data-cp-review-summary]');
    var successPanel = root.querySelector('[data-cp-success-panel]');
    var successCopy = root.querySelector('[data-cp-success-copy]');
    var successReference = root.querySelector('[data-cp-success-reference]');
    var reasonInput = root.querySelector('[data-cp-withdrawal-reason]');
    var noteInput = root.querySelector('[data-cp-withdrawal-note]');
    var confirmInput = root.querySelector('[data-cp-withdrawal-confirm]');
    var paymentOptionInput = root.querySelector('[data-cp-payment-option]');
    var panels = root.querySelectorAll('[data-cp-step-panel]');
    var indicators = root.querySelectorAll('[data-cp-step-indicator]');
    var bootstrap = parseJSON(root.querySelector('[data-cp-withdrawal-customer-orders]'), {});
    var customerLoggedIn = !!(bootstrap && bootstrap.schemaVersion === 3 && bootstrap.customer && bootstrap.customer.loggedIn === true);
    bootstrap = null;
    var accountOrdersEnabled = root.dataset.accountOrdersEnabled !== 'false';
    var accountOrders = [];
    var activeOrders = [];
    var selectedOrder = null;
    var accountLoading = false;
    var accountGeneration = 0;
    var submitInFlight = false;
    var accountOrdersUrl = sameOriginViewUrl(root.dataset.accountOrdersUrl || '');
    var returnShippingFeeProductHandle = root.dataset.returnShippingFeeProductHandle || 'return-shipping-fee';
    var returnShippingFeeVariantId = root.dataset.returnShippingFeeVariantId || '';
    var accountLoginUrl = root.dataset.accountLoginUrl || '/account/login';
    var accountRegisterUrl = root.dataset.accountRegisterUrl || '/account/register';
    var returnShippingFeeDisplay = root.dataset.returnShippingFeeDisplay || '€12';
    var returnShippingFeeCurrency = root.dataset.returnShippingFeeCurrency || 'EUR';
    var requestTimeout = parseInt(root.dataset.requestTimeout || '9000', 10);
    var returnWindowDays = 30;
    if (!Number.isFinite(requestTimeout) || requestTimeout < 1000 || requestTimeout > 30000) requestTimeout = 9000;

    function getInitialStep() {
      return customerLoggedIn ? 2 : 1;
    }

    function syncSurfaceHeightToSidebar() {
      if (!asideNode || !surfaceNode) return;

      if (window.matchMedia && window.matchMedia('(max-width: 990px)').matches) {
        root.style.removeProperty('--cp-withdrawal-sidebar-height');
        surfaceNode.style.minHeight = '';
        return;
      }

      var sidebarHeight = Math.ceil(asideNode.getBoundingClientRect().height);
      if (!sidebarHeight) return;

      root.style.setProperty('--cp-withdrawal-sidebar-height', sidebarHeight + 'px');
      surfaceNode.style.minHeight = sidebarHeight + 'px';
    }

    function setAccountSelectResultsVisible(hasResults) {
      if (!selectPanel) return;
      selectPanel.classList.toggle('has-order-results', !!hasResults);
      if (!hasResults) {
        selectPanel.classList.remove('has-selected-order');
      }
    }

    function setAccountSelectOrderSelected(hasSelectedOrder) {
      if (!selectPanel) return;
      selectPanel.classList.toggle('has-selected-order', !!hasSelectedOrder);
    }

    var cancelHelperTextNode = root.querySelector('[data-cp-cancel-helper-text]');

    function setCancelHelperVisible(isVisible, actionType) {
      if (cancelHelperTextNode) {
        cancelHelperTextNode.textContent = actionType === 'cancel'
          ? 'All eligible products are selected. Deselect any items you do not want to cancel.'
          : 'All eligible products are selected. Deselect any items you do not want to return.';
      }

      setHidden(cancelHelperNode, !isVisible);
    }

    function setStep(step) {
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-cp-step-panel') !== String(step);
      });

      indicators.forEach(function (indicator) {
        var isActive = indicator.getAttribute('data-cp-step-indicator') === String(step);
        indicator.classList.toggle('is-active', isActive);
        if (isActive) {
          indicator.setAttribute('aria-current', 'step');
        } else {
          indicator.removeAttribute('aria-current');
        }
      });
    }

    function showMessage(type, text) {
      if (!messageNode) return;
      messageNode.className = 'cp-withdrawal__message is-' + type;
      messageNode.textContent = text;
      messageNode.hidden = false;
    }

    function showMessageWithActions(type, text, actions) {
      if (!messageNode) return;

      messageNode.className = 'cp-withdrawal__message is-' + type;
      messageNode.textContent = '';

      var textNode = document.createElement('span');
      textNode.textContent = text;
      messageNode.appendChild(textNode);

      var validActions = Array.isArray(actions)
        ? actions.filter(function (action) {
            return action && action.text && action.url;
          })
        : [];

      if (validActions.length) {
        var actionsNode = document.createElement('span');
        actionsNode.className = 'cp-withdrawal__message-actions';

        validActions.forEach(function (action) {
          var link = document.createElement('a');
          link.className = 'cp-withdrawal__message-action' + (action.primary ? ' is-primary' : '');
          link.href = action.url;
          link.textContent = action.text;
          actionsNode.appendChild(link);
        });

        messageNode.appendChild(actionsNode);
      }

      messageNode.hidden = false;
    }

    function getGuestAccountActions() {
      return [
        {
          text: 'Log in',
          url: accountLoginUrl,
          primary: true
        },
        {
          text: 'Create account',
          url: accountRegisterUrl
        }
      ];
    }

    function showAccountOrders() {
      if (!customerLoggedIn || accountLoading || submitInFlight) return;
      if (!accountOrdersEnabled) {
        setStep(2);
        showMessage('error', 'Account orders are currently unavailable for this withdrawal form. Please contact customer support.');
        setHidden(retryAccountOrdersButton, true);
        return;
      }
      var generation = ++accountGeneration;
      clearMessage();
      setStep(2);
      accountOrders = [];
      activeOrders = [];
      selectedOrder = null;
      setHidden(requestForm, true);
      setAccountSelectResultsVisible(false);
      if (itemsNode) itemsNode.textContent = '';
      if (ordersNode) ordersNode.textContent = 'Loading your orders...';
      setAccountBusy(true);

      fetchAccountOrders()
        .then(function (data) {
          if (generation !== accountGeneration) return;
          if (!data || data.schemaVersion !== 3 || !data.customer || typeof data.customer.loggedIn !== 'boolean') {
            throw new Error('Invalid account response');
          }
          if (data.customer.loggedIn === false) {
            customerLoggedIn = false;
            setStep(1);
            showMessageWithActions('error', 'Please log in again to view your orders securely.', getGuestAccountActions());
            setHidden(retryAccountOrdersButton, true);
            return;
          }
          accountOrders = normalizeAccountOrders(data);
          clearMessage();
          if (!accountOrders.length) {
            if (ordersNode) ordersNode.textContent = 'No orders are available to cancel or return yet.';
            return;
          }
          renderOrders(accountOrders);
        })
        .catch(function (error) {
          if (generation !== accountGeneration) return;
          if (window.console && window.console.warn) {
            window.console.warn('[cp-withdrawal] account-orders-load-failed');
          }
          accountOrders = [];
          activeOrders = [];
          if (ordersNode) ordersNode.textContent = '';
          if (error && (error.status === 401 || error.status === 403)) {
            showMessageWithActions('error', 'Please log in again to view your orders securely.', getGuestAccountActions());
          } else {
            showMessage('error', 'The withdrawal service is temporarily unavailable. Please try again.');
          }
          setHidden(retryAccountOrdersButton, false);
        })
        .finally(function () {
          if (generation === accountGeneration) setAccountBusy(false);
        });
    }

    function fetchAccountOrders() {
      if (!accountOrdersUrl) return Promise.reject(new Error('Withdrawal orders view unavailable'));
      var timeout = withTimeout(requestTimeout);
      // Do not send Accept: application/json here. Shopify treats a JSON Accept header on /cart as a
      // request for the cart JSON and ignores ?view=, so the orders template would never render.
      return fetch(accountOrdersUrl, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        signal: timeout.signal
      }).then(function (response) {
        if (!response.ok) throw createRequestError('Account request failed', response);
        if (response.redirected && !sameOriginViewUrl(response.url)) {
          var loginError = createRequestError('Account session required', response);
          loginError.status = 401;
          throw loginError;
        }
        return response.text();
      }).then(function (text) {
        try {
          return JSON.parse(text);
        } catch (error) {
          var parseError = new Error('Invalid account response');
          parseError.detail = String(text || '').slice(0, 300);
          throw parseError;
        }
      }).finally(function () {
        timeout.clear();
      });
    }

    function clearMessage() {
      if (!messageNode) return;
      messageNode.textContent = '';
      messageNode.hidden = true;
      messageNode.className = 'cp-withdrawal__message';
    }

    function setAccountBusy(isBusy) {
      accountLoading = isBusy;
      if (ordersNode) ordersNode.setAttribute('aria-busy', String(isBusy));
      if (retryAccountOrdersButton) {
        retryAccountOrdersButton.disabled = isBusy;
        if (isBusy) retryAccountOrdersButton.hidden = true;
      }
    }

    function setSubmitBusy(isBusy) {
      submitInFlight = isBusy;
      if (submitForm) submitForm.setAttribute('aria-busy', String(isBusy));
      root.querySelectorAll('[data-cp-withdrawal-request-form] input, [data-cp-withdrawal-request-form] select, [data-cp-withdrawal-request-form] textarea, [data-cp-withdrawal-submit-form] input').forEach(function (input) {
        var itemId = input.getAttribute('data-item-id');
        var item = selectedOrder && selectedOrder.items.find(function (candidate) { return candidate.id === itemId; });
        input.disabled = isBusy || (input.hasAttribute('data-cp-item-select') && (!item || !item.selectable));
      });
      root.querySelectorAll('[data-cp-order-id]').forEach(function (button) {
        var order = activeOrders.find(function (candidate) { return candidate.id === button.getAttribute('data-cp-order-id'); });
        button.disabled = isBusy || !getWithdrawalEligibility(order).eligible;
      });
      if (backToRequestButton) backToRequestButton.disabled = isBusy;
      if (startAgainButton) startAgainButton.disabled = isBusy;
      if (nextStepButton) nextStepButton.disabled = isBusy;
      if (submitButton) submitButton.disabled = isBusy;
      if (submitButtonText) submitButtonText.textContent = isBusy ? 'Submitting...' : 'Continue to payment';
    }

    function setNextStepBusy(isBusy) {
      if (nextStepButton) nextStepButton.disabled = isBusy;
      if (nextStepButtonText) nextStepButtonText.textContent = isBusy ? 'Checking...' : 'Next step';
    }

    function getDateOnly(value) {
      var raw = String(value || '').trim();
      var match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
      var parsed;

      if (match) {
        parsed = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
      } else if (raw) {
        parsed = new Date(raw);
      }

      if (!parsed || Number.isNaN(parsed.getTime())) return null;
      return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    }

    function getOrderAgeDays(order) {
      var orderDate = getDateOnly(order.processedAtRaw || order.processedAt);
      if (!orderDate) return null;

      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return Math.floor((today.getTime() - orderDate.getTime()) / 86400000);
    }

    function getOrderStatusText(order) {
      return String(order && (order.fulfillmentStatus || order.status || '') || '').trim();
    }

    function isCancelledOrder(order) {
      var status = normalizeActionStatus([
        getOrderStatusText(order),
        order && order.financialStatus
      ].filter(Boolean).join(' '));

      return !!(
        order &&
        (order.cancelled || order.cancelledAt || status === 'cx' || status.indexOf('cancel') !== -1 || status.indexOf('void') !== -1)
      );
    }

    function isUnfulfilledOrder(order) {
      var status = normalizeActionStatus(getOrderStatusText(order));
      return !status || status.indexOf('unfulfilled') !== -1;
    }

    function getOrderFlow(order) {
      if (!order) {
        return {
          action: 'return',
          eligible: true,
          message: '',
          optionLabel: 'Return',
          statusLabel: 'Order'
        };
      }

      var statusLabel = getOrderStatusText(order) || 'Order';
      if (order.withdrawalEligible === false) {
        return { action: 'none', eligible: false, message: order.withdrawalMessage || 'This order is not available to cancel or return.', optionLabel: 'Not available', statusLabel: statusLabel };
      }

      if (isCancelledOrder(order)) {
        return {
          action: 'none',
          eligible: false,
          message: 'No cancellation or return options are available for cancelled orders.',
          optionLabel: '',
          statusLabel: 'Cancelled'
        };
      }

      if (isUnfulfilledOrder(order)) {
        return {
          action: 'cancel',
          eligible: true,
          message: '',
          optionLabel: 'Cancel order',
          statusLabel: statusLabel || 'Unfulfilled'
        };
      }

      var ageDays = getOrderAgeDays(order);
      if (ageDays !== null && ageDays > returnWindowDays) {
        return {
          action: 'none',
          eligible: false,
          message: 'No return options are available after ' + returnWindowDays + ' days.',
          optionLabel: 'Not available',
          statusLabel: statusLabel
        };
      }

      return {
        action: 'return',
        eligible: true,
        message: '',
        optionLabel: 'Return',
        statusLabel: statusLabel
      };
    }

    function getWithdrawalEligibility(order) {
      var flow = getOrderFlow(order);
      return {
        eligible: flow.eligible,
        message: flow.message
      };
    }

    function getOrderSubtitle(order) {
      var parts = [];
      if (order.processedAt) parts.push(order.processedAt);
      if (order.total) parts.push(order.total);
      if (order.financialStatus) parts.push(order.financialStatus);
      return parts.join(' / ');
    }

    function renderOrders(orders) {
      activeOrders = orders.slice();
      selectedOrder = null;
      setHidden(requestForm, true);
      setCancelHelperVisible(false);
      setAccountSelectOrderSelected(false);

      if (!ordersNode) return;

      if (!activeOrders.length) {
        ordersNode.innerHTML = '<div class="cp-withdrawal__message is-info">No matching orders were found.</div>';
        setAccountSelectResultsVisible(false);
        return;
      }

      ordersNode.innerHTML = activeOrders
        .map(function (order) {
          var flow = getOrderFlow(order);
          var eligibility = {
            eligible: flow.eligible,
            message: flow.message
          };
          var hasInitiatedItem = Array.isArray(order.items) && order.items.some(function (item) {
            return !!item.withdrawalInitiated;
          });
          var hasSelectableItem = Array.isArray(order.items) && order.items.some(function (item) {
            return item.selectable;
          });
          var isCancelled = isCancelledOrder(order);
          var status = flow.statusLabel || order.fulfillmentStatus || 'Order';
          var classes = 'cp-withdrawal-order' + (eligibility.eligible ? '' : ' is-disabled');
          var disabledAttr = eligibility.eligible ? '' : ' disabled aria-disabled="true"';
          var warning = eligibility.eligible
            ? ''
            : '<span class="cp-withdrawal-order__warning">' + escapeHTML(eligibility.message) + '</span>';
          var orderRadio = eligibility.eligible
            ? '<span class="cp-withdrawal-order__radio" aria-hidden="true"></span>'
            : '<span class="cp-withdrawal-order__radio-spacer" aria-hidden="true"></span>';
          var orderOption = '';

          if (eligibility.eligible && hasInitiatedItem) {
            status = order.returnRequestStatus || 'Return requested';
          }

          if (eligibility.eligible && hasSelectableItem && flow.action === 'cancel') {
            orderOption = '<span class="cp-withdrawal-order__cancel" data-cp-cancel-order data-cp-select-full-order>Cancel order</span>';
          } else if (eligibility.eligible && hasSelectableItem && flow.action === 'return') {
            orderOption = '<span class="cp-withdrawal-order__option cp-withdrawal-order__option--return" data-cp-select-full-order>Return</span>';
          } else if (!eligibility.eligible && !isCancelled) {
            orderOption = '<span class="cp-withdrawal-order__option cp-withdrawal-order__option--none">Not available</span>';
          }

          return [
            '<button class="' + classes + '" type="button" data-cp-order-id="' + escapeHTML(order.id) + '"' + disabledAttr + '>',
            orderRadio,
            '<span class="cp-withdrawal-order__body">',
            '<span class="cp-withdrawal-order__title">' + escapeHTML(order.name) + '</span>',
            '<span class="cp-withdrawal-order__meta">' + escapeHTML(getOrderSubtitle(order)) + '</span>',
            warning,
            '</span>',
            '<span class="cp-withdrawal-order__side">',
            '<span class="cp-withdrawal-order__status">' + escapeHTML(status) + '</span>',
            orderOption,
            '</span>',
            '</button>'
          ].join('');
        })
        .join('');

      setAccountSelectResultsVisible(true);
      setStep(2);
    }

    function renderItems(order) {
      if (!itemsNode) return;

      if (!order.items.length) {
        itemsNode.innerHTML = '<div class="cp-withdrawal__message is-info">No products are available to cancel or return on this order.</div>';
        return;
      }

      itemsNode.innerHTML = order.items
        .map(function (item) {
          var max = item.returnableQuantity;
          var isInitiated = !!item.withdrawalInitiated;
          var selectControl = isInitiated
            ? '<span class="cp-withdrawal-item__select-spacer" aria-hidden="true"></span>'
            : '<input type="checkbox" data-cp-item-select data-item-id="' + escapeHTML(item.id) + '"' + (item.selectable ? '' : ' disabled') + '>';
          var quantityControl = '<span class="cp-withdrawal-item__qty-value" data-cp-item-qty-value data-item-id="' + escapeHTML(item.id) + '">' + escapeHTML(max) + '</span>';
          var meta = [];
          if (item.variantTitle && item.variantTitle !== 'Default Title') meta.push(item.variantTitle);
          if (item.sku) meta.push('SKU ' + item.sku);
          if (isInitiated) meta.push('Return requested');

          return [
            '<label class="cp-withdrawal-item' + (isInitiated ? ' is-withdrawal-initiated' : '') + '">',
            selectControl,
            item.image
              ? '<span class="cp-withdrawal-item__image"><img src="' + escapeHTML(item.image) + '" alt=""></span>'
              : '<span class="cp-withdrawal-item__placeholder" aria-hidden="true">CP</span>',
            '<span class="cp-withdrawal-item__body">',
            '<span class="cp-withdrawal-item__title">' + escapeHTML(item.title) + '</span>',
            isInitiated ? '<span class="cp-withdrawal-item__badge">Return requested</span>' : '',
            '<span class="cp-withdrawal-item__meta">' + escapeHTML(meta.join(' / ')) + '</span>',
            '</span>',
            '<span class="cp-withdrawal-item__qty">',
            '<span>Qty</span>',
            quantityControl,
            '</span>',
            '</label>'
          ].join('');
        })
        .join('');
    }

    function selectAllItemsForSelectedOrder() {
      if (!selectedOrder || !selectedOrder.items.length) return 0;

      var selectedCount = 0;

      selectedOrder.items.forEach(function (item) {
        if (!item.selectable) return;

        var checkbox = findByDataItem(root, '[data-cp-item-select]', item.id);
        var qtyInput = findByDataItem(root, '[data-cp-item-qty]', item.id);
        var max = item.returnableQuantity || item.quantity || 1;

        if (checkbox && !checkbox.disabled) {
          checkbox.checked = true;
          selectedCount += 1;
        }

        if (qtyInput && !qtyInput.disabled) {
          qtyInput.value = max;
        }
      });

      return selectedCount;
    }

    function selectOrder(orderId, options) {
      if (submitInFlight) return;
      var shouldSelectFullOrder = !!(options && options.selectFullOrder);

      selectedOrder = activeOrders.find(function (order) {
        return String(order.id) === String(orderId);
      });

      if (selectedOrder && !getWithdrawalEligibility(selectedOrder).eligible) {
        setHidden(requestForm, true);
        setAccountSelectOrderSelected(false);
        return;
      }

      root.querySelectorAll('.cp-withdrawal-order').forEach(function (button) {
        button.classList.toggle('is-selected', button.getAttribute('data-cp-order-id') === String(orderId));
      });

      if (selectedOrder) {
        var selectedOrderFlow = getOrderFlow(selectedOrder);
        setCancelHelperVisible(false);
        renderItems(selectedOrder);
        if (shouldSelectFullOrder) {
          var selectedCount = selectAllItemsForSelectedOrder();
          if (selectedCount) {
            setCancelHelperVisible(true, selectedOrderFlow.action);
            showMessage('info', selectedOrderFlow.action === 'cancel'
              ? 'All available products have been selected to cancel this order.'
              : 'All available products have been selected for this return.');
          } else {
            showMessage('info', 'Return already requested for all products on this order.');
          }
        }
        setHidden(requestForm, false);
        setAccountSelectOrderSelected(true);
      } else {
        setAccountSelectOrderSelected(false);
      }
    }

    function getSelectedItems() {
      if (!selectedOrder) return [];

      if (!selectedOrder.items.length) return [];

      return selectedOrder.items
        .filter(function (item) {
          if (!item.selectable) return false;
          var checkbox = findByDataItem(root, '[data-cp-item-select]', item.id);
          return checkbox && checkbox.checked;
        })
        .map(function (item) {
          var qtyInput = findByDataItem(root, '[data-cp-item-qty]', item.id);
          var max = item.returnableQuantity || item.quantity || 1;
          var qty = qtyInput ? parseInt(qtyInput.value || max, 10) : max;

          if (!qty || qty < 1) qty = 1;
          if (qty > max) qty = max;

          return {
            id: item.id,
            itemRef: item.itemRef,
            lineItemId: item.lineItemId,
            title: item.title,
            variantTitle: item.variantTitle,
            sku: item.sku,
            quantity: qty,
            unitPrice: item.unitPrice || 0,
            unitPriceMinor: item.unitPriceMinor || 0,
            currency: item.currency || returnShippingFeeCurrency
          };
        });
    }

    function validateSelectedRequest() {
      if (!selectedOrder) {
        showMessage('error', 'Select the order you want to cancel or return.');
        return false;
      }

      var orderEligibility = getWithdrawalEligibility(selectedOrder);
      if (!orderEligibility.eligible) {
        showMessage('error', orderEligibility.message);
        return false;
      }

      if (!getSelectedItems().length) {
        var allItemsInitiated = selectedOrder.items.length > 0 && selectedOrder.items.every(function (item) {
          return !!item.withdrawalInitiated;
        });

        if (allItemsInitiated) {
          showMessage('info', 'Return already requested for all products on this order.');
          return false;
        }

        showMessage('error', 'Select at least one item from the order.');
        return false;
      }

      return true;
    }

    function validatePaymentOption() {
      if (paymentOptionInput && !root.querySelector('[data-cp-payment-option]:checked')) {
        showMessage('error', 'Confirm the return shipping payment option.');
        paymentOptionInput.focus();
        return false;
      }

      return true;
    }

    function renderReviewSummary() {
      if (!reviewSummary || !selectedOrder) return;

      var items = getSelectedItems();
      var productSummary = items.length
        ? items.map(function (item) {
            var name = item.title || 'Selected product';
            if (item.variantTitle && item.variantTitle !== 'Default Title') {
              name += ' / ' + item.variantTitle;
            }

            return '<span>' + escapeHTML(name) + '<em>Qty ' + escapeHTML(item.quantity || 1) + '</em></span>';
          }).join('')
        : '<span>Selected products will show here</span>';

      reviewSummary.innerHTML = [
        '<div class="cp-withdrawal-review__row"><span>Order</span><strong>' + escapeHTML(selectedOrder.name) + '</strong></div>',
        '<div class="cp-withdrawal-review__row"><span>Products selected</span><strong class="cp-withdrawal-review__products">' + productSummary + '</strong></div>',
        '<div class="cp-withdrawal-review__row"><span>Return shipping charge</span><strong>' + escapeHTML(returnShippingFeeDisplay) + '</strong></div>'
      ].join('');

      if (submitButtonText) {
        submitButtonText.textContent = 'Continue to payment';
      }
    }

    function buildRequestPayload() {
      if (!customerLoggedIn || !selectedOrder) throw new Error('Please reload your account orders before submitting.');
      var note = noteInput ? noteInput.value.trim() : '';
      if (note.length > 5000) throw new Error('Please keep your message to 5,000 characters or fewer.');
      var reasonCode = reasonInput ? reasonInput.value : '';
      var allowedReasons = ['', 'UNKNOWN', 'COLOR', 'DEFECTIVE', 'NOT_AS_DESCRIBED', 'OTHER', 'SIZE_TOO_LARGE', 'SIZE_TOO_SMALL', 'STYLE', 'UNWANTED', 'WRONG_ITEM'];
      if (allowedReasons.indexOf(reasonCode) === -1) throw new Error('Choose a valid reason.');
      var option = reasonInput && reasonInput.options[reasonInput.selectedIndex];
      return { order: selectedOrder, items: getSelectedItems(), reasonCode: reasonCode,
        reason: option && reasonCode ? option.text : '', note: note, requestedAt: new Date().toISOString(),
        requestedAction: getOrderFlow(selectedOrder).action === 'cancel' ? 'cancel' : 'return' };
    }

    function getNumericVariantId(value) {
      var raw = String(value || '');
      var gidMatch = raw.match(/ProductVariant\/(\d+)/);
      return gidMatch ? gidMatch[1] : raw.replace(/\D/g, '');
    }

    function normalizeProductHandle(value) {
      return String(value || '').trim().replace(/^https?:\/\/[^/]+/i, '').replace(/^\/?products\//, '')
        .replace(/\.js$/, '').replace(/^\/+|\/+$/g, '');
    }

    function resolveReturnShippingVariantIds() {
      var fallback = getNumericVariantId(returnShippingFeeVariantId);
      var handle = normalizeProductHandle(returnShippingFeeProductHandle);
      if (!handle) return fallback ? Promise.resolve([fallback]) : Promise.reject(new Error('Missing return shipping product'));
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { method: 'GET', headers: { Accept: 'application/json' },
        credentials: 'same-origin', cache: 'no-store' }).then(function (response) {
        if (!response.ok) throw createRequestError('Return shipping product lookup failed', response);
        return parseResponseJSON(response);
      }).then(function (product) {
        var ids = product && Array.isArray(product.variants) ? product.variants.filter(function (variant) { return variant.available !== false; })
          .map(function (variant) { return getNumericVariantId(variant.id); }).filter(Boolean) : [];
        if (!ids.length) throw new Error('Return shipping product has no variants');
        return ids;
      }).catch(function (error) { if (fallback) return [fallback]; throw error; });
    }

    function itemLabel(item) {
      var label = item.title || 'Selected product';
      if (item.variantTitle && item.variantTitle.toLowerCase() !== 'default title') label += ' / ' + item.variantTitle;
      if (item.sku) label += ' / SKU ' + item.sku;
      return label;
    }

    function checkoutDetails(request, variantId) {
      var selectedProducts = request.items.map(function (item) { return itemLabel(item) + ' x ' + item.quantity; }).join(', ');
      var selectedItems = JSON.stringify(request.items.map(function (item) {
        return { lineItemId: item.lineItemId, title: item.title, variantTitle: item.variantTitle, sku: item.sku, quantity: item.quantity };
      }));
      var properties = { 'Return request': request.order.name, 'Selected products': selectedProducts,
        '_Selected return items': selectedItems, 'Return reason': request.reason, '_Return reason code': request.reasonCode,
        'Return note': request.note, '_Return requested at': request.requestedAt, 'Requested action': request.requestedAction };
      var attributes = { 'Withdrawal status': 'Payment pending', 'Withdrawal requested items': selectedProducts,
        'Return request': request.order.name, 'Selected products': selectedProducts, 'Selected return items': selectedItems,
        'Return reason': request.reason, 'Return reason code': request.reasonCode, 'Return note': request.note,
        'Return requested at': request.requestedAt, 'Requested action': request.requestedAction };
      var note = ['Withdrawal requested - return shipping payment', 'Original order: ' + request.order.name,
        'Requested item(s): ' + selectedProducts, 'Return shipping fee: ' + returnShippingFeeDisplay];
      if (request.reason) note.push('Reason: ' + request.reason);
      if (request.note) note.push('Customer message: ' + request.note);
      return { variantId: variantId, properties: properties, attributes: attributes, note: note.join('\n') };
    }

    function parseCartResponse(response) {
      return parseResponseJSON(response).then(function (data) { if (!response.ok) throw createRequestError('Cart update failed', response); return data; });
    }

    function clearCartForIsolatedCheckout() {
      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({})
      }).then(parseCartResponse);
    }

    function prepareReturnShippingCheckout(request) {
      return resolveReturnShippingVariantIds().then(function (ids) {
        if (!ids[0]) throw new Error('Missing return shipping product');
        return clearCartForIsolatedCheckout().then(function () { return checkoutDetails(request, ids[0]); });
      }).then(function (details) {
        return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: details.variantId, quantity: 1, properties: details.properties }] }) })
          .then(parseCartResponse).then(function () { return details; });
      }).then(function (details) {
        return fetch('/cart/update.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, credentials: 'same-origin',
          body: JSON.stringify({ attributes: details.attributes, note: details.note }) }).then(parseCartResponse);
      });
    }

    function resetAttempt() {}

    window.addEventListener('pageshow', function () { setSubmitBusy(false); });

    if (retryAccountOrdersButton) retryAccountOrdersButton.addEventListener('click', showAccountOrders);
    if (customerLoggedIn) showAccountOrders();
    else setStep(1);

    syncSurfaceHeightToSidebar();
    window.requestAnimationFrame(syncSurfaceHeightToSidebar);
    window.addEventListener('resize', syncSurfaceHeightToSidebar);
    window.addEventListener('load', syncSurfaceHeightToSidebar);
    window.setTimeout(syncSurfaceHeightToSidebar, 250);
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      accountGeneration += 1;
      setAccountBusy(false);
      setSubmitBusy(false);
      accountOrders = [];
      activeOrders = [];
      selectedOrder = null;
      if (itemsNode) itemsNode.textContent = '';
      if (ordersNode) ordersNode.textContent = '';
      if (reviewSummary) reviewSummary.textContent = '';
      setHidden(requestForm, true);
      setHidden(submitForm, false);
      setHidden(successPanel, true);
      if (customerLoggedIn) showAccountOrders();
    });

    if (backToLookupButton) backToLookupButton.addEventListener('click', function () {
      if (submitInFlight) return;
      clearMessage();
      setStep(1);
    });
    if (backToRequestButton) backToRequestButton.addEventListener('click', function () {
      if (submitInFlight) return;
      clearMessage();
      setStep(2);
    });
    if (ordersNode) ordersNode.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cp-order-id]');
      if (!button || button.disabled) return;
      selectOrder(button.getAttribute('data-cp-order-id'), {
        selectFullOrder: !!event.target.closest('[data-cp-select-full-order]')
      });
    });
    if (startAgainButton) startAgainButton.addEventListener('click', function () {
      if (submitInFlight) return;
      selectedOrder = null;
      if (requestForm) requestForm.reset();
      if (submitForm) submitForm.reset();
      setHidden(submitForm, false);
      setHidden(successPanel, true);
      if (reviewSummary) reviewSummary.textContent = '';
      if (reasonInput) reasonInput.value = '';
      if (noteInput) noteInput.value = '';
      clearMessage();
      if (customerLoggedIn) showAccountOrders();
      else setStep(getInitialStep());
    });

    if (requestForm) {
      requestForm.addEventListener('input', resetAttempt);
      requestForm.addEventListener('change', resetAttempt);
      requestForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (submitInFlight) return;
        clearMessage();
        setNextStepBusy(true);
        if (!validateSelectedRequest()) {
          setNextStepBusy(false);
          return;
        }
        renderReviewSummary();
        setHidden(submitForm, false);
        setHidden(successPanel, true);
        setStep(3);
        setNextStepBusy(false);
        if (paymentOptionInput) paymentOptionInput.focus();
      });
    }
    root.querySelectorAll('[data-cp-payment-option]').forEach(function (input) {
      input.addEventListener('change', resetAttempt);
    });
    if (submitForm) submitForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (submitInFlight) return;
      clearMessage();
      if (!validateSelectedRequest() || !validatePaymentOption()) return;
      if (confirmInput && !confirmInput.checked) {
        showMessage('error', 'Confirm that you want to submit this withdrawal or return request.');
        confirmInput.focus();
        return;
      }
      var request;
      try {
        request = buildRequestPayload();
      } catch (error) {
        showMessage('error', error.message);
        return;
      }
      setSubmitBusy(true);
      prepareReturnShippingCheckout(request).then(function () {
        window.location.assign('/checkout');
      }).catch(function (error) {
        showMessage('error', error && error.message ? error.message : 'We could not prepare checkout. Please try again.');
        setSubmitBusy(false);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cp-withdrawal-form]').forEach(initWithdrawalForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-cp-withdrawal-form]').forEach(initWithdrawalForm);
  });
})();
